import { useDispatch, useSelector } from 'react-redux'
import {
  selectCurrentSeason,
  selectCurrentSeasonProgress,
} from '../../../modules/seasons/selectors'
import AnimatedLoader from '../../../shared_components/AnimatedLoader'
import { Box } from '../../../shared_components/UI/Box'
import { selectAccount } from '../../../modules/web3/selectors'
import AboutThisSeason from './About'
import SeasonProgress from './Progress'
import { useLocation } from 'react-router-dom'
import SeasonComplete from './SeasonComplete'
import { ThemedButton } from '../../../shared_components/ThemedButton'
import useWeb3 from '../../../hooks/useWeb3'
import { H3 } from '../../../shared_components/Library/Typeography'
import {
  useGetPreviousSeasonsProgressQuery,
  useGetPreviousSeasonsQuery,
} from '../../../modules/seasons/api'
import { useEffect } from 'react'
import {
  setPastSeasonProgress,
  setPastSeasons,
  UserSeasonProgress,
  SerializedUserSeasonProgress,
} from '../../../modules/seasons/slice'
import PreviousSeasons from './PreviousSeasons'

const isComingSoon = true

export default function Season() {
  const account = useSelector(selectAccount)

  const currentSeason = useSelector(selectCurrentSeason)
  const currentSeasonProgress = useSelector(selectCurrentSeasonProgress)

  const isLoggedIn = !!account

  const dispatch = useDispatch()

  const { data: previousSeasonsData } = useGetPreviousSeasonsQuery({ account })
  const { data: previousSeasonsProgressData } =
    useGetPreviousSeasonsProgressQuery(
      { account },
      {
        skip: !isLoggedIn,
      },
    )

  useEffect(() => {
    if (!previousSeasonsProgressData) return
    const serialised: { [seasonId: string]: UserSeasonProgress } =
      previousSeasonsProgressData.reduce(
        (acc, progress: UserSeasonProgress) => {
          acc[progress.seasonId] = progress
          return acc
        },
        {} as SerializedUserSeasonProgress,
      )
    dispatch(setPastSeasonProgress(serialised))
  }, [previousSeasonsProgressData])

  useEffect(() => {
    if (!previousSeasonsData) return
    dispatch(setPastSeasons(previousSeasonsData))
  }, [previousSeasonsData])

  const { initWeb3 } = useWeb3()

  const shouldPromptSeasonAccept =
    !!currentSeasonProgress &&
    !currentSeasonProgress?.hasAcknowledgedStart &&
    isLoggedIn

  const displayLoader = !currentSeason || (!currentSeasonProgress && isLoggedIn)

  const location = useLocation()

  if (isComingSoon) return <AboutThisSeason isComingSoon />

  const isPreviousScreen = location.pathname.includes('previous')
  const searchParams = new URLSearchParams(location.search)
  const modal = searchParams.get('modal')
  const isAboutModal = modal === 'about'
  const isQuestCompleteModal = modal === 'quest-complete'

  const isSeasonComplete = currentSeason?.winners?.length > 0

  if (!isLoggedIn) {
    return (
      <Box c marginBottom={69.42} marginTop={69.42} dc g={16}>
        <H3 s="L">Sign in or register</H3>
        <ThemedButton onClick={initWeb3} $styleType="primary">
          Connect
        </ThemedButton>
      </Box>
    )
  }

  if (displayLoader) {
    return (
      <Box c marginTop={69.42}>
        <AnimatedLoader onlyWhite />
      </Box>
    )
  }

  const modalDismissable = isAboutModal || isQuestCompleteModal

  if (isPreviousScreen) return <PreviousSeasons />
  if (isSeasonComplete) return <SeasonComplete />

  if (shouldPromptSeasonAccept || modalDismissable) {
    return <AboutThisSeason dismissable={modalDismissable} />
  }

  return <SeasonProgress />
}
